import { ModelingLanguage } from "@kea-mod/common";

interface PaletteGroup {
  language: ModelingLanguage;
  labelKey: string;
}

export interface PaletteNotation {
  key: string;
  labelKey: string;
  groups: PaletteGroup[];
}

export const paletteNotations: PaletteNotation[] = [
  {
    key: "er",
    labelKey: "header_navbar_item_er",
    groups: [{ language: ModelingLanguage.ER, labelKey: "header_navbar_item_er" }],
  },
  {
    key: "epc",
    labelKey: "header_navbar_item_epk",
    groups: [{ language: ModelingLanguage.EPC, labelKey: "header_navbar_item_epk" }],
  },
  {
    key: "pn",
    labelKey: "header_navbar_item_petri",
    groups: [{ language: ModelingLanguage.PN, labelKey: "header_navbar_item_petri" }],
  },
  {
    key: "bpmn",
    labelKey: "header_navbar_item_bpmn",
    groups: [
      { language: ModelingLanguage.BPMN, labelKey: "palette_group_general" },
      { language: ModelingLanguage.BPMN_SWIMLANE, labelKey: "palette_group_swimlanes" },
      { language: ModelingLanguage.BPMN_EVENT, labelKey: "palette_group_events" },
      { language: ModelingLanguage.BPMN_GATEWAY, labelKey: "palette_group_gateways" },
      { language: ModelingLanguage.BPMN_ACTIVITY, labelKey: "palette_group_activities" },
    ],
  },
  {
    key: "uml_cd",
    labelKey: "header_navbar_item_class",
    groups: [{ language: ModelingLanguage.UML_CD, labelKey: "header_navbar_item_class" }],
  },
  {
    key: "uml_sd",
    labelKey: "header_navbar_item_state",
    groups: [{ language: ModelingLanguage.UML_SD, labelKey: "header_navbar_item_state" }],
  },
  {
    key: "uml_ad",
    labelKey: "header_navbar_item_ad",
    groups: [
      { language: ModelingLanguage.UML_AD, labelKey: "palette_group_general" },
      { language: ModelingLanguage.UML_AD_SWIMLANE, labelKey: "palette_group_swimlanes" },
    ],
  },
  {
    key: "uml_seq",
    labelKey: "header_navbar_item_seq",
    groups: [
      { language: ModelingLanguage.UML_SEQ, labelKey: "palette_group_general" },
      { language: ModelingLanguage.UML_SEQD_FRAME, labelKey: "palette_group_frames" },
    ],
  },
];

export const findNotation = (language: ModelingLanguage): PaletteNotation | undefined =>
  paletteNotations.find((notation) => notation.groups.some((group) => group.language === language));
